import axios from '@axios'

export default {
    namespaced: true,
    state: {
        // Mantenimiento
        roles: [],
        establecimientos: [],
        fabricas: [],
        centrosCostos: [],
        subcentrosCostos: [],

        // Configuracion
        usuarios: [],

        //Menu
        opcionesTurno: [
            { text: 'Día', value: 'D' },
            { text: 'Noche', value: 'N' },
        ],
        empleados: [],
        asistencia: [],
        submotivos: [],
        empleadosPorSeccion: [],
        empleadosNuevos: [],
    },
    getters: {
        // Mantenimiento
        getRoles: state => state.roles,
        getEstablecimientos: state => state.establecimientos,
        getFabricas: state => state.fabricas,
        getCentrosCostos: state => state.centrosCostos,
        getSubcentrosCostos: state => state.subcentrosCostos,

        // Configuracion
        getUsuarios: state => state.usuarios,

        // Menu
        getOpcionesTurno: state => state.opcionesTurno,
        getEmpleados: state => state.empleados,
        getAsistencia: state => state.asistencia,
        getSubmotivos: state => state.submotivos,
        getEmpleadosPorSeccion: state => state.empleadosPorSeccion,
        getEmpleadosNuevos: state => state.empleadosNuevos,
    },
    mutations: {
        // Mantenimiento
        SET_ROLES(state, roles) {
            state.roles = roles
        },
        SET_ESTABLECIMIENTOS(state, establecimientos) {
            state.establecimientos = establecimientos
        },
        SET_FABRICAS(state, fabricas) {
            state.fabricas = fabricas
        },
        SET_CENTROSCOSTOS(state, centrosCostos) {
            state.centrosCostos = centrosCostos
        },
        SET_SUBCENTROSCOSTOS(state, subcentrosCostos) {
            state.subcentrosCostos = subcentrosCostos
        },

        // Configuracion
        SET_USUARIOS(state, usuarios) {
            state.usuarios = usuarios
        },
        SET_EMPLEADOS_POR_SECCION(state, empleadosPorSeccion) {
            state.empleadosPorSeccion = empleadosPorSeccion
        },

        SET_EMPLEADOS(state, empleados) {
            state.empleados = empleados
        },
        SET_ASISTENCIA(state, asistencia) {
            state.asistencia = asistencia
        },
        SET_ASISTENCIA_GENERAL(state, asistenciaGeneral) {
            state.asistenciaGeneral = asistenciaGeneral
        },
        SET_HORAS_TRABAJADAS(state, horasTrabajadas) {
            state.horasTrabajadas = horasTrabajadas
        },
        SET_SUBMOTIVOS(state, submotivos) {
            state.submotivos = submotivos
        },
        SET_EMPLEADOS_NUEVOS(state, empleadosNuevos) {
            state.empleadosNuevos = empleadosNuevos
        },
    },
    actions: {
        // Mantenimiento
        fetchRoles({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/roles')
                    .then(response => {
                        commit('SET_ROLES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstablecimientos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/establecimientos')
                    .then(response => {
                        commit('SET_ESTABLECIMIENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabricas({ commit }, data) {
            commit('SET_FABRICAS', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/fabricas', { params: data })
                    .then(response => {
                        commit('SET_FABRICAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSeccionesRHasistencia(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/seccionesRHasistencia', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCentrosCostos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/centrosCostos', { params: data })
                    .then(response => {
                        commit('SET_CENTROSCOSTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSubcentrosCostos({ commit }, co_cc) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsistencia/subcentrosCostos/${co_cc}`)
                    .then(response => {
                        commit('SET_SUBCENTROSCOSTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarSeccion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/guardarSeccion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Configuracion
        fetchUsuarios({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/usuarios')
                    .then(response => {
                        commit('SET_USUARIOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRolesPS() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/rolesPS')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstablecimientosPS(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/establecimientosPS', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabricasPS(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/fabricasPS', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPermisoSeccionesRH(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/permisoSeccionesRH', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarPermisoSeccion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/guardarPermisoSeccion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSeccionesRhPorUsuario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/seccionesRhPorUsuario', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTurnosEmpleados(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/turnosEmpleados', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTurnosFaltantes(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/turnosFaltantes', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarTurnos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/guardarTurnos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarTurnosMasivo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/guardarTurnosMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarTurno(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/guardarTurno', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Menu
        fetchEstablecimientosMenu(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/establecimientosMenu', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabricasMenu(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/fabricasMenu', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSecciones({ commit }, co_fabrica) {
            commit('SET_SECCIONES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsistencia/secciones/${co_fabrica}`)
                    .then(response => {
                        commit('SET_SECCIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSeccionesRH(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/seccionesRH', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpleadosPorSeccion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/empleadosPorSeccion', { params: data })
                    .then(response => {
                        // commit('SET_EMPLEADOS_POR_SECCION', response.data);
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/empleados', { params: data })
                    .then(response => {
                        const empleados = response.data.map(e => {
                            e.movimiento = e.biometrico?.justificacion?.movimiento
                            return e
                        })
                        commit('SET_EMPLEADOS', empleados)
                        resolve(empleados)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSubmotivos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/submotivos', { params: data })
                    .then(response => {
                        commit('SET_SUBMOTIVOS', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAsistencia({ commit }, data) {
            commit('SET_ASISTENCIA', [])
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsistencia/asistencia`, { params: data })
                    .then(response => {
                        commit('SET_ASISTENCIA', response.data)
                        resolve(response.data.length)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        vaciarAsistencia({ commit }) {
            commit('SET_ASISTENCIA', [])
        },
        fetchEmpleadosPresentes(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsistencia/empleadosPresentes`, { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpleadosTransferidos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsistencia/empleadosTransferidos`, { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpleadosTransferenciaDevolucion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsistencia/empleadosTransferenciaDevolucion`, { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postIngresarAsistencia(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/ingresarAsistencia', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postIngresarAsistenciaJustificada(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/ingresarAsistenciaJustificada', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarEmpleadoAsistencia(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/eliminarEmpleadoLista', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postTransferirPersonal(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/transferirPersonal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postDevolverPersonal(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/devolverPersonal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAceptar(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/aceptar', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postRechazar(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/rechazar', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDashboardInfo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/dashboardInfo', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Informes
        fetcInformeAsistencias(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/informeAsistencias', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetcInformeHorasTrabajadas(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/informeHorasTrabajadas', { params: data })
                    .then(response => {
                        response.data.map(e => {
                            e.mode = 'span'
                            e.html = true
                            return e
                        })
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMovimientosColaborador(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/movimientoColaborador', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTransferencias(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/transferencias', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpleadosNuevos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsistencia/empleadosNuevos', { params: data })
                    .then(response => {
                        commit('SET_EMPLEADOS_NUEVOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postIngresarAsistenciaNuevos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsistencia/ingresarEmpleadosNuevos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
